import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import { NgForm } from "@angular/forms";
import { QuestionBankService } from "../../services/question-bank.service";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";

@Component({
  selector: "app-question-bank-add-new-written-modal",
  templateUrl: "./question-bank-add-new-qa-modal.component.html",
  styleUrls: ["./question-bank-add-new-qa-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankNewQueAddQAComponent implements OnInit {
  answerForm: FormGroup;
  sortOrder: number = 0;
  entity: any = {};
  correctAnsweIndex: number;

  public masterData: any = {};
  formData = {
    can_alter_quesion: "",
    can_type_answer: "",
    answer: "",
    marks: "",
    auto_id: "",
  };


  isEdit: number;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;
  @Input() header_id_2: number;

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private QuestionBankService: QuestionBankService,
    private frmbuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    localStorage.removeItem("question-bank-edit-auto-id");
    this.header_id_2 = Number(localStorage.getItem("question-bank-edit-header-id"));
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  addQAAnswers(formData: any) {
    const requestData = {
      can_alter_quesion: formData.can_alter_quesion,
      can_type_answer: formData.can_type_answer,
      answer: formData.answer,
      marks: formData.marks,
      company_id: this.companySystemID,
      header_id: this.auto_id,
      header_detail_id: this.header_id_2,
    };
    //console.log(requestData);

    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.header_id = that.auto_id;
    //console.log(that.masterData);
    that.QuestionBankService.createNewQAQuestionBank()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added a new question";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-add-new-qa-modal/question-bank-add-new-qa-modal.component.ts